import { useEffect, useState } from "react";
import TopNav from "./components/TopNav";
import Hero from "./components/Hero";
import Trending from "./components/Trending";
import GossipSection from "./components/GossipSection";
import ImpactSection from "./components/ImpactSection";
import NewsFeed from "./components/NewsFeed";
import SubscribeSection from "./components/SubscribeSection";
import GuideSection from "./components/GuideSection";
import FaqSection from "./components/FaqSection";
import Footer from "./components/Footer";
import { celebrities, streamers } from "@/mocks/gossip";

function BackToTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 700);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  if (!show) return null;
  return (
    <a
      href="#top"
      aria-label="返回顶部"
      className="fixed bottom-6 right-6 z-50 grid h-11 w-11 place-items-center rounded-full bg-primary-500 text-background-50 shadow-lg transition hover:bg-primary-600"
    >
      <i className="ri-arrow-up-line text-lg" />
    </a>
  );
}

export default function Home() {
  return (
    <>
      <TopNav />
      <main>
        <Hero />
        <Trending />
        <GossipSection
          id="star"
          eyebrow="Celebrity · 明星八卦"
          title="明星八卦：戏里戏外都有好戏"
          sub="番位、绯闻、转型与公关，明星的一举一动都是话题。我们带你拆解背后的门道，也记得把戏和戏外分开看。"
          items={celebrities}
          tone="primary"
          actionLabel="查看更多明星八卦"
        />
        <GossipSection
          id="streamer"
          eyebrow="Influencer · 网红主播"
          title="网红主播：流量江湖的起落"
          sub="直播间里的每一句“家人们”，背后都是流量与人设的较量。带货、塌房、翻盘，这里是主播世界的真实切片。"
          items={streamers}
          tone="accent"
          actionLabel="看看主播圈更多瓜"
        />
        <ImpactSection />
        <NewsFeed />
        <GuideSection />
        <FaqSection />
        <SubscribeSection />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}